export enum MacroIdentifier {
  Sequence = 'sequence',
  Graph = 'graph'
}